import React from 'react';
import { PlayCircle, ExternalLink } from 'lucide-react';
export function MediaSection() {
  return <section id="media" className="py-24 bg-[#0d1321] px-4 sm:px-6 lg:px-8" data-id="element-135">
      <div className="max-w-7xl mx-auto" data-id="element-136">
        <div className="text-center mb-16" data-id="element-137">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-138">
            Media & Appearances
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-cyan-400 to-blue-500 mx-auto rounded-full mb-6" data-id="element-139"></div>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-140">
            Watch Arthur discuss the future of financial infrastructure,
            post-quantum security, and ethical innovation.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 mb-12" data-id="element-141">
          {/* Podcast 1 */}
          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-4 border border-white/10 shadow-sm" data-id="element-142">
            <div className="aspect-w-16 aspect-h-9 rounded-xl overflow-hidden bg-[#0B1120] relative mb-4" data-id="element-143">
              <iframe src="https://www.youtube.com/embed/HP_rj8-P2AY" title="Arthur Miller Podcast Interview" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full absolute inset-0 rounded-xl" style={{
              minHeight: '300px'
            }} data-id="element-144"></iframe>
            </div>
            <h3 className="text-xl font-bold text-white px-2" data-id="element-145">
              Architecting Trust at Scale
            </h3>
            <p className="text-slate-400 px-2 mt-2" data-id="element-146">
              Deep dive into the foundational principles behind FiQIS and the
              future of banking.
            </p>
          </div>

          {/* Podcast 2 */}
          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-4 border border-white/10 shadow-sm" data-id="element-147">
            <div className="aspect-w-16 aspect-h-9 rounded-xl overflow-hidden bg-[#0B1120] relative mb-4" data-id="element-148">
              <iframe src="https://www.youtube.com/embed/6zZkMNVoEW8" title="Arthur Miller Podcast Interview 2" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full absolute inset-0 rounded-xl" style={{
              minHeight: '300px'
            }} data-id="element-149"></iframe>
            </div>
            <h3 className="text-xl font-bold text-white px-2" data-id="element-150">
              The Post-Quantum Banking Era
            </h3>
            <p className="text-slate-400 px-2 mt-2" data-id="element-151">
              Discussing the critical need for advanced encryption in modern
              financial systems.
            </p>
          </div>
        </div>

        {/* Fox 5 Feature */}
        <div className="bg-gradient-to-br from-cyan-900/50 to-blue-900/50 backdrop-blur-md rounded-2xl p-8 md:p-12 text-center text-white relative overflow-hidden mb-16 border border-cyan-500/20 glow-cyan" data-id="element-152">
          <div className="absolute top-0 right-0 w-64 h-64 bg-cyan-500/20 rounded-full blur-3xl opacity-50 transform translate-x-1/2 -translate-y-1/2" data-id="element-153"></div>
          <div className="relative z-10" data-id="element-154">
            <span className="inline-block px-4 py-1 bg-cyan-500/20 text-cyan-300 text-sm font-bold tracking-wider uppercase rounded-full mb-6 border border-cyan-500/30" data-id="element-155">
              Television Feature
            </span>
            <h3 className="text-2xl md:text-3xl font-bold mb-4 text-white" data-id="element-156">
              Fox 5 San Diego: Innovator's Journey
            </h3>
            <p className="text-slate-300 text-lg max-w-2xl mx-auto mb-8" data-id="element-157">
              Watch the exclusive feature on how Arthur Miller's FiQIS is
              transforming finance and tackling the hidden costs of legacy
              banking infrastructure.
            </p>
            <a href="https://fox5sandiego.com/fox-5-partners/innovators-journey/arthur-millers-fiqis-is-transforming-finance/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-8 py-3.5 bg-cyan-400 text-black font-bold rounded-lg hover:bg-cyan-300 transition-colors shadow-lg" data-id="element-158">
              <PlayCircle className="h-5 w-5" data-id="element-159" />
              Watch Feature on Fox 5
            </a>
          </div>
        </div>

        {/* Additional Podcast Appearances */}
        <div className="mt-16" data-id="element-160">
          <div className="text-center mb-12" data-id="element-161">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-162">
              Additional Podcast Appearances
            </h3>
            <p className="text-slate-400" data-id="element-163">
              More conversations on fintech innovation, leadership, and the
              future of banking.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-164">
            <a href="https://youtube.com/watch?v=HP_rj8-P2AY" target="_blank" rel="noopener noreferrer" className="group bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 hover:border-cyan-500/30 hover:bg-white/10 transition-all" data-id="element-165">
              <div className="flex items-start justify-between mb-3" data-id="element-166">
                <span className="text-sm font-bold text-cyan-400 uppercase tracking-wider" data-id="element-167">
                  YouTube
                </span>
                <ExternalLink className="h-4 w-4 text-slate-400 group-hover:text-cyan-400 transition-colors" data-id="element-168" />
              </div>
              <h4 className="text-lg font-bold text-white group-hover:text-cyan-300 transition-colors mb-2" data-id="element-169">
                Architecting Trust at Scale
              </h4>
              <p className="text-sm text-slate-400" data-id="element-170">
                Deep dive into the foundational principles behind FiQIS and the
                future of banking.
              </p>
            </a>

            <a href="https://youtube.com/watch?v=6zZkMNVoEW8" target="_blank" rel="noopener noreferrer" className="group bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 hover:border-cyan-500/30 hover:bg-white/10 transition-all" data-id="element-171">
              <div className="flex items-start justify-between mb-3" data-id="element-172">
                <span className="text-sm font-bold text-cyan-400 uppercase tracking-wider" data-id="element-173">
                  YouTube
                </span>
                <ExternalLink className="h-4 w-4 text-slate-400 group-hover:text-cyan-400 transition-colors" data-id="element-174" />
              </div>
              <h4 className="text-lg font-bold text-white group-hover:text-cyan-300 transition-colors mb-2" data-id="element-175">
                The Post-Quantum Banking Era
              </h4>
              <p className="text-sm text-slate-400" data-id="element-176">
                Discussing the critical need for advanced encryption in modern
                financial systems.
              </p>
            </a>
          </div>
        </div>
      </div>
    </section>;
}